export { type BaseSchema } from "./base";

import { VERSION } from "./v1";
export {
  type Dataset,
  type Datasource,
  type EventConfig,
  type File,
  type ImagePanelClip,
  type ImagePanelConfig,
  type ImagePanelState,
  type Layout,
  type LayoutItem,
  type LogPanelConfig,
  type LogPanelState,
  type MapPanelInitParams,
  type MapPanelState,
  type PanelState,
  type PanelStates,
  type PlotPanelConfig,
  type PlotPanelInitParams,
  type PlotPanelState,
  type PlotSeries,
  type RawMessagePanelState,
  type ThreeDPanelInitParams,
  type ThreeDPanelState,
  type ThreeDPanelConfig,
  type ThreeDEntity,
  type TopicData,
  type TopicDataPathBinding as TopicDataPathMapping,
  type State,
  type ViewportSyncMode,
  isImagePanelState,
  isLayoutItem,
  isLogPanelState,
  isMapPanelState,
  isPlotPanelState,
  isRawMessagePanelState,
  isThreeDPanelState,
  LegendPosition,
  LayoutType,
  PanelType,
  schema as vizSchema,
  TimeBoundsSource,
} from "./v1";

export const CURRENT_VIZ_SCHEMA_VERSION = VERSION;
